<div class="section-header d-flex justify-content-between align-items-center p-3 bg-light border-bottom">
  <h5 class="mb-0 fw-bold">Notificaciones</h5>
</div>

<div *ngIf="!locationId" class="info-box m-3">
  <mat-icon>info</mat-icon>
  <span>Guarda los datos generales del centro de trabajo para configurar las notificaciones.</span>
</div>

<div *ngIf="locationId" class="notif-section container-fluid py-3">

  <div *ngIf="isLoading" class="text-center py-4">
    <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    <p class="text-muted">Cargando configuración…</p>
  </div>

  <form *ngIf="!isLoading" [formGroup]="form" (ngSubmit)="save()" novalidate>
    <p class="text-muted mb-3">
      Activa las notificaciones automáticas que quieras enviar a tus clientes y a tu equipo.
      Los recordatorios se programan al confirmar la cita; cancelaciones y reprogramaciones se envían en el momento.
    </p>

    <h6 class="block-title">Recordatorios al cliente</h6>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="reminder24hEnabled" />
        Recordatorio 24h antes de la cita (N7)
      </label>
    </div>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="reminderShortEnabled" />
        Recordatorio corto (N8)
      </label>
      <span class="hours">
        <input type="number" min="1" max="72" formControlName="reminderHoursBefore" />
        horas antes
      </span>
    </div>

    <h6 class="block-title">Cambios en la cita</h6>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="cancellationEnabled" />
        Email al cancelar (cliente + staff) (N9)
      </label>
    </div>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="rescheduleEnabled" />
        Email al reprogramar (cliente + staff) (N10)
      </label>
    </div>

    <h6 class="block-title">Reseñas</h6>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="reviewInvitationEnabled" />
        Invitación a reseña 24h tras la cita (N11)
      </label>
    </div>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="reviewResponseEnabled" />
        Avisar al cliente cuando respondes a una reseña (N12)
      </label>
    </div>

    <h6 class="block-title">Pagos</h6>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="paymentReceivedEnabled" />
        Pago recibido (N13)
      </label>
    </div>

    <div class="row-toggle">
      <label>
        <input type="checkbox" formControlName="refundProcessedEnabled" />
        Reembolso procesado (N14)
      </label>
    </div>

    <div class="actions">
      <app-button
        label="Guardar cambios"
        icon="save"
        variant="primary"
        type="submit"
        [loading]="isSaving"
        [disabled]="form.invalid">
      </app-button>
    </div>
  </form>
</div>
